
export default class recaptchaAccessibility {
    constructor() {
        let $form = $('.formify-form');
        let $recaptcha = '.grecaptcha-badge iframe';

        if (!$form.length) {
            return;
        }

        $form.keydown(e => {
            $recaptcha = $form.find($recaptcha);

            if (!$recaptcha.length || $recaptcha.attr('tabindex') === '-1') {
                return;
            }

            $recaptcha.attr('tabindex', '-1');
        });
    }
}
